import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isRootNode, isRegularNode, SchemaCombinerName, SchemaNodeKind, isReferenceNode, isMirroredNode, SchemaTree } from '@stoplight/json-schema-tree';
import { Box, HStack, Flex, Icon, Text, Link, VStack, Select, Menu, Pressable, Provider } from '@stoplight/mosaic';
import { withErrorBoundary } from '@stoplight/react-error-boundary';
import cn from 'classnames';
import { atom, useAtom, Provider as Provider$1 } from 'jotai';
import { atomFamily, useUpdateAtom, useAtomValue } from 'jotai/utils';
import * as React from 'react';
import { useState, useEffect } from 'react';
import last from 'lodash/last.js';
import { MarkdownViewer } from '@stoplight/markdown-viewer';
import { getLastPathSegment, extractPointerFromRef, pointerToPath } from '@stoplight/json';
import upperFirst from 'lodash/upperFirst.js';
import capitalize from 'lodash/capitalize.js';
import keys from 'lodash/keys.js';
import omit from 'lodash/omit.js';
import pick from 'lodash/pick.js';
import uniq from 'lodash/uniq.js';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var JSVOptionsContext = React.createContext({
  defaultExpandedDepth: 0,
  viewMode: 'standalone',
  hideExamples: false
});

var useJSVOptionsContext = function useJSVOptionsContext() {
  return React.useContext(JSVOptionsContext);
};

var JSVOptionsContextProvider = JSVOptionsContext.Provider;
var hoveredNodeAtom = atom(null);
var isNodeHoveredAtom = atomFamily(function (node) {
  return atom(function (get) {
    return node === get(hoveredNodeAtom);
  });
});
atomFamily(function (parent) {
  return atom(function (get) {
    var hoveredNode = get(hoveredNodeAtom);
    if (!hoveredNode || hoveredNode === parent) return false;
    return hoveredNode.parent === parent;
  });
});
var showPathCrumbsAtom = atom(false);
var pathCrumbsAtom = atom(function (get) {
  var node = get(hoveredNodeAtom);
  if (!node) return [];
  return propertyPathToObjectPath(node);
});

function propertyPathToObjectPath(node) {
  var objectPath = [];
  var currentNode = node;

  while (currentNode && !isRootNode(currentNode)) {
    if (isRegularNode(currentNode)) {
      var pathPart = currentNode.subpath[currentNode.subpath.length - 1];

      if (currentNode.primaryType === 'array') {
        var key = "".concat(pathPart || '', "[]");

        if (objectPath[objectPath.length - 1]) {
          objectPath[objectPath.length - 1] = key;
        } else {
          objectPath.push(key);
        }
      } else if (pathPart && (currentNode.subpath.length !== 2 || !['allOf', 'oneOf', 'anyOf'].includes(currentNode.subpath[0]))) {
        objectPath.push(currentNode.subpath[currentNode.subpath.length - 1]);
      }
    }

    currentNode = currentNode.parent;
  }

  return objectPath.reverse();
}

var PathCrumbs = function PathCrumbs(_ref) {
  var _ref$parentCrumbs = _ref.parentCrumbs,
      parentCrumbs = _ref$parentCrumbs === void 0 ? [] : _ref$parentCrumbs;

  var _useAtom = useAtom(showPathCrumbsAtom),
      _useAtom2 = _slicedToArray(_useAtom, 1),
      showPathCrumbs = _useAtom2[0];

  var _useAtom3 = useAtom(pathCrumbsAtom),
      _useAtom4 = _slicedToArray(_useAtom3, 1),
      pathCrumbs = _useAtom4[0];

  var _useJSVOptionsContext = useJSVOptionsContext(),
      disableCrumbs = _useJSVOptionsContext.disableCrumbs;

  if (disableCrumbs) {
    return null;
  }

  var parentCrumbElems = [];
  parentCrumbs.forEach(function (crumb, i) {
    parentCrumbElems.push(React.createElement(Box, {
      key: i
    }, crumb));
  });
  var pathCrumbElems = [];
  pathCrumbs.forEach(function (crumb, i) {
    if (pathCrumbs[i + 1]) {
      pathCrumbElems.push(React.createElement(Box, {
        key: i
      }, crumb));
    } else {
      pathCrumbElems.push(React.createElement(Box, {
        key: i,
        color: "body",
        fontWeight: "semibold"
      }, crumb));
    }
  });

  if (!showPathCrumbs || !parentCrumbElems.length && !pathCrumbElems.length) {
    return null;
  }

  return React.createElement(HStack, {
    spacing: 1,
    divider: React.createElement(Box, null, "/"),
    h: "md",
    mt: -8,
    borderB: true,
    pos: "sticky",
    top: 0,
    fontFamily: "mono",
    fontSize: "sm",
    lineHeight: "none",
    zIndex: 10,
    bg: "canvas-pure",
    px: "px",
    color: "light",
    alignItems: "center"
  }, parentCrumbElems, pathCrumbElems.length && React.createElement(HStack, {
    divider: React.createElement(Box, {
      fontWeight: "bold"
    }, ".")
  }, pathCrumbElems));
};

var _ref2 = {};

_defineProperty(_ref2, SchemaCombinerName.AllOf, 'and');

_defineProperty(_ref2, SchemaCombinerName.AnyOf, 'and/or');

_defineProperty(_ref2, SchemaCombinerName.OneOf, 'or');

_ref2;
var COMMON_JSON_SCHEMA_AND_OAS_FORMATS = {
  number: ['byte', 'int32', 'int64', 'float', 'double'],

  get integer() {
    return this.number;
  }

};
var NESTING_OFFSET = 3;
var CARET_ICON_SIZE = 'sm';
var COMBINER_NAME_MAP = {
  allOf: 'all of',
  anyOf: 'any of',
  oneOf: 'one of'
};

function isNonNullable(maybeNullable) {
  return maybeNullable !== void 0 && maybeNullable !== null;
}

var isNonEmptyParentNode = function isNonEmptyParentNode(node) {
  return isRegularNode(node) && !!node.children && node.children.length > 0;
};

function isFlattenableNode(node) {
  if (!isRegularNode(node)) return false;

  if (node.primaryType !== SchemaNodeKind.Array || !isNonNullable(node.children) || node.children.length === 0) {
    return false;
  }

  return node.children.length === 1 && (isRegularNode(node.children[0]) || isReferenceNode(node.children[0]) && node.children[0].error !== null);
}

function isPrimitiveArray(node) {
  return isFlattenableNode(node) && isRegularNode(node.children[0]) && node.children[0].simple;
}

function isComplexArray(node) {
  return isFlattenableNode(node) && isRegularNode(node.children[0]) && !node.children[0].simple;
}

function calculateChildrenToShow(node) {
  var _a, _b;

  if (!isRegularNode(node) || isPrimitiveArray(node)) {
    return [];
  }

  if (isComplexArray(node)) {
    return (_a = node.children[0].children) !== null && _a !== void 0 ? _a : [];
  }

  return (_b = node.children) !== null && _b !== void 0 ? _b : [];
}

function isPropertyRequired(schemaNode) {
  var _a;

  var parent = schemaNode.parent;

  if (parent === null || !isRegularNode(parent) || schemaNode.subpath.length === 0) {
    return false;
  }

  return !!((_a = parent.required) === null || _a === void 0 ? void 0 : _a.includes(schemaNode.subpath[schemaNode.subpath.length - 1]));
}

var Caret = function Caret(_ref3) {
  var isExpanded = _ref3.isExpanded;
  return React.createElement(Flex, {
    pl: 3,
    w: 8,
    ml: -8,
    color: "muted",
    role: "button",
    justifyContent: "center"
  }, React.createElement(Icon, {
    size: CARET_ICON_SIZE,
    fixedWidth: true,
    icon: isExpanded ? 'chevron-down' : 'chevron-right'
  }));
};

var Description = function Description(_ref4) {
  var value = _ref4.value;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showAll = _React$useState2[0],
      setShowAll = _React$useState2[1];

  var paragraphs = value.split('\n\n');

  if (paragraphs.length <= 1 || showAll) {
    return React.createElement(Box, {
      as: MarkdownViewer,
      markdown: value,
      style: {
        fontSize: 12
      }
    });
  }

  var firstParagraph = paragraphs[0];
  return React.createElement(Box, {
    as: MarkdownViewer,
    markdown: firstParagraph,
    parseOptions: {
      components: {
        p: function p(props) {
          return React.createElement(Box, {
            as: "p"
          }, React.createElement(Text, {
            mr: 1
          }, props.children), React.createElement(Link, {
            cursor: "pointer",
            onClick: function onClick() {
              return setShowAll(true);
            }
          }, "Show all..."));
        }
      }
    },
    style: {
      fontSize: 12
    }
  });
};

var Format = function Format(_ref5) {
  var format = _ref5.format;
  return React.createElement(Box, {
    as: "span",
    color: "muted"
  }, "<".concat(format, ">"));
};

function printName(schemaNode) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$shouldUseRefNam = _ref6.shouldUseRefNameFallback,
      shouldUseRefNameFallback = _ref6$shouldUseRefNam === void 0 ? false : _ref6$shouldUseRefNam;

  var _a;

  if (schemaNode.primaryType !== SchemaNodeKind.Array || !isNonNullable(schemaNode.children) || schemaNode.children.length === 0) {
    return (_a = schemaNode.title) !== null && _a !== void 0 ? _a : shouldUseRefNameFallback ? getNodeNameFromOriginalRef(schemaNode) : undefined;
  }

  return printArrayName(schemaNode, {
    shouldUseRefNameFallback: shouldUseRefNameFallback
  });
}

function printArrayName(schemaNode, _ref7) {
  var _ref7$shouldUseRefNam = _ref7.shouldUseRefNameFallback,
      shouldUseRefNameFallback = _ref7$shouldUseRefNam === void 0 ? false : _ref7$shouldUseRefNam;

  var _a, _b, _c, _d;

  if (!isNonNullable(schemaNode.children) || schemaNode.children.length === 0) {
    return (_a = schemaNode.title) !== null && _a !== void 0 ? _a : shouldUseRefNameFallback ? getNodeNameFromOriginalRef(schemaNode) : undefined;
  }

  if (schemaNode.children.length === 1 && isReferenceNode(schemaNode.children[0])) {
    return "$ref(".concat(schemaNode.children[0].value, ")[]");
  }

  if (isPrimitiveArray(schemaNode)) {
    var val = (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.reduce(function (mergedTypes, child) {
      if (mergedTypes === null) return null;
      if (!isRegularNode(child)) return null;

      if (child.types !== null && child.types.length > 0) {
        var _iterator = _createForOfIteratorHelper(child.types),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var type = _step.value;
            if (mergedTypes.includes(type)) continue;
            mergedTypes.push(type);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return mergedTypes;
    }, [])) !== null && _c !== void 0 ? _c : null;
    return val !== null && val.length > 0 ? "array[".concat(val.join(' or '), "]") : 'array';
  }

  if (isComplexArray(schemaNode)) {
    var firstChild = schemaNode.children[0];

    if (firstChild.title) {
      return "array[".concat(firstChild.title, "]");
    } else if (shouldUseRefNameFallback && getNodeNameFromOriginalRef(schemaNode)) {
      return "array[".concat(getNodeNameFromOriginalRef(schemaNode), "]");
    } else if (firstChild.primaryType) {
      return "array[".concat(firstChild.primaryType, "]");
    } else if ((_d = firstChild.combiners) === null || _d === void 0 ? void 0 : _d.length) {
      return "array[".concat(firstChild.combiners.join('/'), "]");
    }

    return 'array';
  }

  return undefined;
}

function getNodeNameFromOriginalRef(node) {
  if (typeof node.originalFragment.$ref === 'string') {
    return upperFirst(getLastPathSegment(node.originalFragment.$ref));
  }

  return undefined;
}

function shouldRenderName(type) {
  return type === SchemaNodeKind.Array || type === SchemaNodeKind.Object || type === '$ref';
}

function getTypes(schemaNode) {
  return [schemaNode.types, schemaNode.combiners].reduce(function (values, value) {
    if (value === null) {
      return values;
    }

    values.push.apply(values, _toConsumableArray(value));
    return values;
  }, []);
}

function getFormats(schemaNode) {
  var formats = {};

  if (isPrimitiveArray(schemaNode) && schemaNode.children[0].format !== null) {
    formats.array = schemaNode.children[0].format;
  }

  if (schemaNode.format === null) {
    return formats;
  }

  var types = getTypes(schemaNode);

  var _iterator2 = _createForOfIteratorHelper(types),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var type = _step2.value;
      if (!(type in COMMON_JSON_SCHEMA_AND_OAS_FORMATS)) continue;

      if (COMMON_JSON_SCHEMA_AND_OAS_FORMATS[type].includes(schemaNode.format)) {
        formats[type] = schemaNode.format;
        return formats;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  formats.string = schemaNode.format;
  return formats;
}

var Types = function Types(_ref8) {
  var schemaNode = _ref8.schemaNode;

  var _a;

  if (isReferenceNode(schemaNode)) {
    return React.createElement(Box, {
      as: "span",
      textOverflow: "truncate"
    }, (_a = schemaNode.value) !== null && _a !== void 0 ? _a : '$ref');
  }

  if (!isRegularNode(schemaNode)) {
    return null;
  }

  var types = getTypes(schemaNode);
  var formats = getFormats(schemaNode);

  if (types.length === 0) {
    return formats.string !== void 0 ? React.createElement(Format, {
      format: formats.string
    }) : null;
  }

  var rendered = types.map(function (type, i, _ref9) {
    var length = _ref9.length;

    var _a;

    return React.createElement(React.Fragment, {
      key: type
    }, React.createElement(Box, {
      as: "span",
      textOverflow: "truncate",
      color: "muted"
    }, shouldRenderName(type) ? (_a = printName(schemaNode)) !== null && _a !== void 0 ? _a : type : type), type in formats ? React.createElement(Format, {
      format: formats[type]
    }) : null, i < length - 1 && React.createElement(Box, {
      as: "span",
      key: "".concat(i, "-sep"),
      color: "muted"
    }, ' or '));
  });
  return rendered.length > 1 ? React.createElement(Box, {
    textOverflow: "truncate"
  }, rendered) : React.createElement(React.Fragment, null, rendered);
};

Types.displayName = 'JsonSchemaViewer.Types';
var numberValidationNames = ['minimum', 'maximum', 'minLength', 'maxLength', 'minItems', 'maxItems', 'exclusiveMinimum', 'exclusiveMaximum'];
var exampleValidationNames = ['examples'];
var excludedValidations = ['exclusiveMinimum', 'exclusiveMaximum', 'readOnly', 'writeOnly'];
var numberValidationFormatters = {
  minimum: function minimum(value) {
    return ">= ".concat(value);
  },
  exclusiveMinimum: function exclusiveMinimum(value) {
    return "> ".concat(value);
  },
  minItems: function minItems(value) {
    return ">= ".concat(value, " items");
  },
  minLength: function minLength(value) {
    return ">= ".concat(value, " characters");
  },
  maximum: function maximum(value) {
    return "<= ".concat(value);
  },
  exclusiveMaximum: function exclusiveMaximum(value) {
    return "< ".concat(value);
  },
  maxItems: function maxItems(value) {
    return "<= ".concat(value, " items");
  },
  maxLength: function maxLength(value) {
    return "<= ".concat(value, " characters");
  }
};

var createStringFormatter = function createStringFormatter(nowrap) {
  return function (value) {
    return nowrap && typeof value === 'string' ? value : JSON.stringify(value);
  };
};

var createValidationsFormatter = function createValidationsFormatter(name, options) {
  return function (value) {
    var values = Array.isArray(value) ? value : [value];

    if (values.length) {
      return {
        name: (options === null || options === void 0 ? void 0 : options.exact) ? name : values.length > 1 ? "".concat(name, "s") : "".concat(name),
        values: values.map(createStringFormatter(options === null || options === void 0 ? void 0 : options.nowrap))
      };
    }

    return null;
  };
};

var validationFormatters = {
  enum: createValidationsFormatter('Allowed value', {
    nowrap: true
  }),
  examples: createValidationsFormatter('Example', {
    nowrap: true
  }),
  multipleOf: createValidationsFormatter('Multiple of', {
    exact: true
  }),
  pattern: createValidationsFormatter('Match pattern', {
    exact: true,
    nowrap: true
  }),
  default: createValidationsFormatter('Default', {
    exact: true,
    nowrap: true
  }),
  style: createValidationsFormatter('Style', {
    exact: true,
    nowrap: true
  })
};
var oasFormats = {
  int32: {
    minimum: 0 - Math.pow(2, 31),
    maximum: Math.pow(2, 31) - 1
  },
  int64: {
    minimum: 0 - Math.pow(2, 63),
    maximum: Math.pow(2, 63) - 1
  },
  float: {
    minimum: 0 - Math.pow(2, 128),
    maximum: Math.pow(2, 128) - 1
  },
  double: {
    minimum: 0 - Number.MAX_VALUE,
    maximum: Number.MAX_VALUE
  },
  byte: {
    pattern: '^[\\w\\d+\\/=]*$'
  }
};

function filterOutOasFormatValidations(format, values) {
  if (!(format in oasFormats)) return values;
  var newValues = Object.assign({}, values);

  for (var _i = 0, _Object$entries = Object.entries(oasFormats[format]); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === newValues[key]) {
      delete newValues[key];
    }
  }

  return newValues;
}

var Validations = function Validations(_ref10) {
  var validations = _ref10.validations,
      hideExamples = _ref10.hideExamples;
  var numberValidations = pick(validations, numberValidationNames);
  var keyValueValidations = omit(validations, [].concat(_toConsumableArray(keys(numberValidations)), excludedValidations, _toConsumableArray(hideExamples ? exampleValidationNames : [])));
  return React.createElement(React.Fragment, null, React.createElement(NumberValidations, {
    validations: numberValidations
  }), React.createElement(KeyValueValidations, {
    validations: keyValueValidations
  }));
};

var NumberValidations = function NumberValidations(_ref11) {
  var validations = _ref11.validations;
  var entries = Object.entries(validations);

  if (!entries.length) {
    return null;
  }

  return React.createElement(HStack, {
    color: "muted",
    maxW: "full",
    spacing: 1
  }, entries.map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        key = _ref13[0],
        value = _ref13[1];

    return numberValidationFormatters[key](value);
  }).map(function (value, i) {
    return React.createElement(Value, {
      key: i,
      name: value
    });
  }));
};

var KeyValueValidations = function KeyValueValidations(_ref14) {
  var validations = _ref14.validations;
  return React.createElement(React.Fragment, null, keys(validations).filter(function (key) {
    return Object.keys(validationFormatters).includes(key) && validations[key] !== void 0;
  }).map(function (key) {
    var validation = validationFormatters[key](validations[key]);

    if (validation) {
      return React.createElement(KeyValueValidation, {
        key: key,
        name: validation.name,
        values: validation.values
      });
    } else {
      return null;
    }
  }));
};

var KeyValueValidation = function KeyValueValidation(_ref15) {
  var name = _ref15.name,
      values = _ref15.values;
  return React.createElement(HStack, {
    color: "muted",
    spacing: 2,
    alignItems: "baseline"
  }, React.createElement(Text, null, capitalize(name), ":"), React.createElement(Flex, {
    flexWrap: true,
    flex: 1,
    style: {
      gap: 4
    }
  }, uniq(values).map(function (value) {
    return React.createElement(Value, {
      key: value,
      name: value
    });
  })));
};

var Value = function Value(_ref16) {
  var name = _ref16.name;
  return React.createElement(Text, {
    px: 1,
    bg: "canvas-tint",
    color: "muted",
    border: true,
    rounded: true,
    wordBreak: "all",
    maxW: "full"
  }, name);
};

function getValidationsFromSchema(schemaNode) {
  var _a;

  return Object.assign(Object.assign(Object.assign({}, schemaNode.enum !== null ? {
    enum: schemaNode.enum
  } : schemaNode.primaryType === 'array' && ((_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) === 1 && isRegularNode(schemaNode.children[0]) && schemaNode.children[0].enum !== null ? {
    enum: schemaNode.children[0].enum
  } : null), 'annotations' in schemaNode ? Object.assign(Object.assign({}, schemaNode.annotations.default !== void 0 ? {
    default: schemaNode.annotations.default
  } : null), schemaNode.annotations.examples ? {
    examples: schemaNode.annotations.examples
  } : null) : null), getFilteredValidations(schemaNode));
}

function getFilteredValidations(schemaNode) {
  if (schemaNode.format !== null) {
    return filterOutOasFormatValidations(schemaNode.format, schemaNode.validations);
  }

  return schemaNode.validations;
}

function getInternalSchemaError(schemaNode, defaultErrorMessage) {
  var errorMessage;
  var fragment = schemaNode.fragment;

  if (typeof fragment === 'object' && fragment !== null) {
    var fragmentErrorMessage = fragment['x-sl-error-message'];

    if (typeof fragmentErrorMessage === 'string') {
      errorMessage = fragmentErrorMessage !== null && fragmentErrorMessage !== void 0 ? fragmentErrorMessage : defaultErrorMessage;
    } else {
      var items = fragment['items'];

      if (typeof items === 'object' && items !== null) {
        var itemsErrorMessage = items['x-sl-error-message'];

        if (typeof itemsErrorMessage === 'string') {
          errorMessage = itemsErrorMessage !== null && itemsErrorMessage !== void 0 ? itemsErrorMessage : defaultErrorMessage;
        }
      }
    }
  }

  return {
    hasError: !!errorMessage,
    error: errorMessage
  };
}

var ChildStack = React.memo(function (_ref17) {
  var childNodes = _ref17.childNodes,
      currentNestingLevel = _ref17.currentNestingLevel,
      className = _ref17.className,
      _ref17$RowComponent = _ref17.RowComponent,
      RowComponent = _ref17$RowComponent === void 0 ? SchemaRow : _ref17$RowComponent;

  var _useJSVOptionsContext2 = useJSVOptionsContext(),
      renderRootTreeLines = _useJSVOptionsContext2.renderRootTreeLines;

  var rootLevel = renderRootTreeLines ? 0 : 1;
  var isRootLevel = currentNestingLevel < rootLevel;
  var ml;

  if (!isRootLevel) {
    ml = currentNestingLevel === rootLevel ? 'px' : 7;
  }

  return React.createElement(Box, {
    className: className,
    ml: ml,
    fontSize: "sm",
    borderL: isRootLevel ? undefined : true,
    "data-level": currentNestingLevel
  }, childNodes.map(function (childNode) {
    return React.createElement(RowComponent, {
      key: childNode.id,
      schemaNode: childNode,
      nestingLevel: currentNestingLevel + 1,
      pl: isRootLevel ? undefined : NESTING_OFFSET
    });
  }));
});

var useHasProperties = function useHasProperties(_ref18) {
  var required = _ref18.required,
      deprecated = _ref18.deprecated,
      _ref18$validations = _ref18.validations,
      readOnly = _ref18$validations.readOnly,
      writeOnly = _ref18$validations.writeOnly;

  var _useJSVOptionsContext3 = useJSVOptionsContext(),
      viewMode = _useJSVOptionsContext3.viewMode;

  var showVisibilityValidations = viewMode === 'standalone' && !!readOnly !== !!writeOnly;
  return deprecated || showVisibilityValidations || required;
};

var Properties = function Properties(_ref19) {
  var required = _ref19.required,
      deprecated = _ref19.deprecated,
      _ref19$validations = _ref19.validations,
      readOnly = _ref19$validations.readOnly,
      writeOnly = _ref19$validations.writeOnly;

  var _useJSVOptionsContext4 = useJSVOptionsContext(),
      viewMode = _useJSVOptionsContext4.viewMode;

  var showVisibilityValidations = viewMode === 'standalone' && !!readOnly !== !!writeOnly;
  var visibility = showVisibilityValidations ? readOnly ? React.createElement(Box, {
    as: "span",
    ml: 2,
    color: "muted"
  }, "read-only") : React.createElement(Box, {
    as: "span",
    ml: 2,
    color: "muted"
  }, "write-only") : null;
  return React.createElement(React.Fragment, null, deprecated ? React.createElement(Box, {
    as: "span",
    ml: 2,
    color: "warning"
  }, "deprecated") : null, visibility, required && React.createElement(Box, {
    as: "span",
    ml: 2,
    color: "warning"
  }, "required"));
};

function calculateChoiceTitle(node, isPlural) {
  var primitiveSuffix = isPlural ? 's' : '';

  if (isRegularNode(node)) {
    var realName = printName(node, {
      shouldUseRefNameFallback: true
    });

    if (realName) {
      return realName;
    }

    return node.primaryType !== null ? node.primaryType + primitiveSuffix : 'any';
  }

  if (isReferenceNode(node)) {
    if (node.value) {
      var value = extractPointerFromRef(node.value);
      var lastPiece = !node.error && value ? last(pointerToPath(value)) : null;

      if (typeof lastPiece === 'string') {
        return lastPiece.split('.')[0];
      }
    }

    return '$ref' + primitiveSuffix;
  }

  return 'any';
}

function makeChoice(node) {
  return {
    type: node,
    title: calculateChoiceTitle(node, false)
  };
}

function makeArrayChoice(node, combiner) {
  var itemTitle = calculateChoiceTitle(node, true);
  var title = itemTitle !== 'any' ? "array ".concat(combiner ? "(".concat(combiner, ")") : null, " [").concat(itemTitle, "]") : 'array';
  return {
    type: node,
    title: title
  };
}

var useChoices = function useChoices(schemaNode) {
  var choices = React.useMemo(function () {
    if (isComplexArray(schemaNode) && isNonEmptyParentNode(schemaNode.children[0]) && shouldShowChildSelector(schemaNode.children[0])) {
      return schemaNode.children[0].children.map(function (child) {
        var _a;

        return makeArrayChoice(child, (_a = schemaNode.children[0].combiners) === null || _a === void 0 ? void 0 : _a[0]);
      });
    }

    if (isNonEmptyParentNode(schemaNode) && shouldShowChildSelector(schemaNode)) {
      return schemaNode.children.map(makeChoice);
    }

    return [makeChoice(schemaNode)];
  }, [schemaNode]);
  var defaultChoice = choices[0];

  var _React$useState3 = React.useState(defaultChoice),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedChoice = _React$useState4[0],
      setSelectedChoice = _React$useState4[1];

  React.useEffect(function () {
    setSelectedChoice(defaultChoice);
  }, [defaultChoice]);
  var actualSelectedChoice = selectedChoice && choices.includes(selectedChoice) ? selectedChoice : defaultChoice;
  return {
    selectedChoice: actualSelectedChoice,
    setSelectedChoice: setSelectedChoice,
    choices: choices
  };
};

var shouldShowChildSelector = function shouldShowChildSelector(schemaNode) {
  var _a, _b;

  return isNonEmptyParentNode(schemaNode) && ['anyOf', 'oneOf'].includes((_b = (_a = schemaNode.combiners) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '');
};

var SchemaRow = React.memo(function (_ref20) {
  var schemaNode = _ref20.schemaNode,
      nestingLevel = _ref20.nestingLevel,
      pl = _ref20.pl;

  var _a;

  var _useJSVOptionsContext5 = useJSVOptionsContext(),
      defaultExpandedDepth = _useJSVOptionsContext5.defaultExpandedDepth,
      renderRowAddon = _useJSVOptionsContext5.renderRowAddon,
      onGoToRef = _useJSVOptionsContext5.onGoToRef,
      hideExamples = _useJSVOptionsContext5.hideExamples,
      renderRootTreeLines = _useJSVOptionsContext5.renderRootTreeLines;

  var setHoveredNode = useUpdateAtom(hoveredNodeAtom);

  var _React$useState5 = React.useState(!isMirroredNode(schemaNode) && nestingLevel <= defaultExpandedDepth),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isExpanded = _React$useState6[0],
      setExpanded = _React$useState6[1];

  var _useChoices = useChoices(schemaNode),
      selectedChoice = _useChoices.selectedChoice,
      setSelectedChoice = _useChoices.setSelectedChoice,
      choices = _useChoices.choices;

  var typeToShow = selectedChoice.type;
  var description = isRegularNode(typeToShow) ? typeToShow.annotations.description : null;
  var refNode = React.useMemo(function () {
    var _a, _b, _c;

    if (isReferenceNode(schemaNode)) {
      return schemaNode;
    }

    if (isRegularNode(schemaNode) && (isFlattenableNode(schemaNode) || schemaNode.primaryType === SchemaNodeKind.Array && ((_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) === 1)) {
      return (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.find(isReferenceNode)) !== null && _c !== void 0 ? _c : null;
    }

    return null;
  }, [schemaNode]);
  var isBrokenRef = typeof (refNode === null || refNode === void 0 ? void 0 : refNode.error) === 'string';
  var rootLevel = renderRootTreeLines ? 1 : 2;
  var childNodes = React.useMemo(function () {
    return calculateChildrenToShow(typeToShow);
  }, [typeToShow]);
  var combiner = isRegularNode(schemaNode) && ((_a = schemaNode.combiners) === null || _a === void 0 ? void 0 : _a.length) ? schemaNode.combiners[0] : null;
  var isCollapsible = childNodes.length > 0;
  var isRootLevel = nestingLevel < rootLevel;
  var required = isPropertyRequired(schemaNode);
  var deprecated = isRegularNode(schemaNode) && schemaNode.deprecated;
  var validations = isRegularNode(schemaNode) ? schemaNode.validations : {};
  var hasProperties = useHasProperties({
    required: required,
    deprecated: deprecated,
    validations: validations
  });
  var internalSchemaError = getInternalSchemaError(schemaNode);
  return React.createElement(React.Fragment, null, React.createElement(Flex, {
    maxW: "full",
    pl: pl,
    py: 2,
    onMouseEnter: function onMouseEnter(e) {
      e.stopPropagation();
      setHoveredNode(selectedChoice.type);
    }
  }, !isRootLevel && React.createElement(Box, {
    borderT: true,
    w: isCollapsible ? 1 : 3,
    ml: -3,
    mr: 3,
    mt: 2
  }), React.createElement(VStack, {
    spacing: 1,
    maxW: "full",
    flex: 1,
    ml: isCollapsible && !isRootLevel ? 2 : undefined
  }, React.createElement(Flex, {
    alignItems: "center",
    maxW: "full",
    onClick: isCollapsible ? function () {
      return setExpanded(!isExpanded);
    } : undefined,
    cursor: isCollapsible ? 'pointer' : undefined
  }, isCollapsible ? React.createElement(Caret, {
    isExpanded: isExpanded
  }) : null, React.createElement(Flex, {
    alignItems: "baseline",
    fontSize: "base"
  }, schemaNode.subpath.length > 0 && shouldShowPropertyName(schemaNode) && React.createElement(Box, {
    mr: 2,
    fontFamily: "mono",
    fontWeight: "semibold"
  }, last(schemaNode.subpath)), choices.length === 1 && React.createElement(Types, {
    schemaNode: typeToShow
  }), onGoToRef && isReferenceNode(schemaNode) && schemaNode.external ? React.createElement(Box, {
    as: "a",
    ml: 2,
    cursor: "pointer",
    color: "primary-light",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onGoToRef(schemaNode);
    }
  }, "(go to ref)") : null, schemaNode.subpath.length > 1 && schemaNode.subpath[0] === 'patternProperties' ? React.createElement(Box, {
    ml: 2,
    color: "muted"
  }, "(pattern property)") : null, choices.length > 1 && React.createElement(Select, {
    "aria-label": "Pick a type",
    size: "sm",
    triggerTextPrefix: combiner ? "".concat(COMBINER_NAME_MAP[combiner], ": ") : undefined,
    options: choices.map(function (choice, index) {
      return {
        value: String(index),
        label: choice.title
      };
    }),
    value: String(choices.indexOf(selectedChoice)),
    onChange: function onChange(selectedIndex) {
      return setSelectedChoice(choices[selectedIndex]);
    }
  })), hasProperties && React.createElement(Divider, {
    atom: isNodeHoveredAtom(schemaNode)
  }), React.createElement(Properties, {
    required: required,
    deprecated: deprecated,
    validations: validations
  })), typeof description === 'string' && description.length > 0 && React.createElement(Description, {
    value: description
  }), React.createElement(Validations, {
    validations: isRegularNode(schemaNode) ? getValidationsFromSchema(schemaNode) : {},
    hideExamples: hideExamples
  }), (isBrokenRef || internalSchemaError.hasError) && React.createElement(Icon, {
    title: (refNode === null || refNode === void 0 ? void 0 : refNode.error) || internalSchemaError.error,
    color: "danger",
    icon: ['fas', 'exclamation-triangle'],
    size: "sm"
  })), renderRowAddon ? React.createElement(Box, null, renderRowAddon({
    schemaNode: schemaNode,
    nestingLevel: nestingLevel
  })) : null), isCollapsible && isExpanded ? React.createElement(ChildStack, {
    schemaNode: schemaNode,
    childNodes: childNodes,
    currentNestingLevel: nestingLevel
  }) : null);
});

var Divider = function Divider(_ref21) {
  var atom = _ref21.atom;
  var isHovering = useAtomValue(atom);
  return React.createElement(Box, {
    bg: isHovering ? 'canvas-200' : undefined,
    h: "px",
    flex: 1,
    mx: 3
  });
};

function shouldShowPropertyName(schemaNode) {
  return schemaNode.subpath.length === 2 && (schemaNode.subpath[0] === 'properties' || schemaNode.subpath[0] === 'patternProperties');
}

var useIsOnScreen = function useIsOnScreen(ref) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isOnScreen = _useState2[0],
      setIsOnScreen = _useState2[1];

  useEffect(function () {
    if (ref.current) {
      var scrollParent = getScrollParent(ref.current);
      var observer = new IntersectionObserver(function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 1),
            entry = _ref23[0];

        setIsOnScreen(entry.isIntersecting);
      }, {
        root: scrollParent === window ? undefined : scrollParent,
        rootMargin: '20px 0px 0px 0px'
      });
      observer.observe(ref.current);
    }

    return function () {};
  }, [ref]);
  return isOnScreen;
};

function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight && node.clientHeight > 0) {
    return node.tagName === 'HTML' ? window : node;
  } else {
    return getScrollParent(node.parentElement);
  }
}

var TopLevelSchemaRow = function TopLevelSchemaRow(_ref24) {
  var schemaNode = _ref24.schemaNode;

  var _a;

  var _useChoices2 = useChoices(schemaNode),
      selectedChoice = _useChoices2.selectedChoice,
      setSelectedChoice = _useChoices2.setSelectedChoice,
      choices = _useChoices2.choices;

  var childNodes = React.useMemo(function () {
    return calculateChildrenToShow(selectedChoice.type);
  }, [selectedChoice.type]);
  var nestingLevel = 0;
  var internalSchemaError = getInternalSchemaError(schemaNode);

  if (isRegularNode(schemaNode) && isPureObjectNode(schemaNode)) {
    return React.createElement(React.Fragment, null, React.createElement(ScrollCheck, null), React.createElement(ChildStack, {
      schemaNode: schemaNode,
      childNodes: childNodes,
      currentNestingLevel: nestingLevel
    }), internalSchemaError.hasError && React.createElement(Icon, {
      title: internalSchemaError.error,
      color: "danger",
      icon: ['fas', 'exclamation-triangle'],
      size: "sm"
    }));
  }

  if (isRegularNode(schemaNode) && choices.length > 1) {
    var combiner = isRegularNode(schemaNode) && ((_a = schemaNode.combiners) === null || _a === void 0 ? void 0 : _a.length) ? schemaNode.combiners[0] : null;
    return React.createElement(React.Fragment, null, React.createElement(ScrollCheck, null), React.createElement(HStack, {
      spacing: 3,
      pb: 4
    }, React.createElement(Menu, {
      "aria-label": "Pick a type",
      closeOnPress: true,
      placement: "bottom left",
      items: choices.map(function (choice, index) {
        return {
          id: index,
          title: choice.title,
          onPress: function onPress() {
            return setSelectedChoice(choice);
          }
        };
      }),
      renderTrigger: function renderTrigger(props) {
        return React.createElement(Pressable, Object.assign({}, props), React.createElement(Flex, {
          fontFamily: "mono",
          fontWeight: "semibold",
          cursor: "pointer",
          fontSize: "base"
        }, selectedChoice.title, React.createElement(Box, {
          ml: 1
        }, React.createElement(Icon, {
          icon: ['fas', 'caret-down']
        }))));
      }
    }), combiner !== null ? React.createElement(Flex, {
      alignItems: "center",
      color: "muted",
      fontSize: "base"
    }, "(".concat(COMBINER_NAME_MAP[combiner], ")")) : null), childNodes.length > 0 ? React.createElement(ChildStack, {
      schemaNode: schemaNode,
      childNodes: childNodes,
      currentNestingLevel: nestingLevel
    }) : null);
  }

  if (isComplexArray(schemaNode) && isPureObjectNode(schemaNode.children[0])) {
    return React.createElement(React.Fragment, null, React.createElement(ScrollCheck, null), React.createElement(Box, {
      fontFamily: "mono",
      fontWeight: "semibold",
      fontSize: "base",
      pb: 4
    }, "array of:"), childNodes.length > 0 ? React.createElement(ChildStack, {
      schemaNode: schemaNode,
      childNodes: childNodes,
      currentNestingLevel: nestingLevel
    }) : null);
  }

  return React.createElement(React.Fragment, null, React.createElement(ScrollCheck, null), React.createElement(SchemaRow, {
    schemaNode: schemaNode,
    nestingLevel: nestingLevel
  }));
};

function ScrollCheck() {
  var elementRef = React.useRef(null);
  var isOnScreen = useIsOnScreen(elementRef);
  var setShowPathCrumbs = useUpdateAtom(showPathCrumbsAtom);
  React.useEffect(function () {
    setShowPathCrumbs(!isOnScreen);
  }, [isOnScreen, setShowPathCrumbs]);
  return React.createElement("div", {
    ref: elementRef
  });
}

function isPureObjectNode(schemaNode) {
  var _a;

  return schemaNode.primaryType === 'object' && ((_a = schemaNode.types) === null || _a === void 0 ? void 0 : _a.length) === 1;
}

var JsonSchemaViewerComponent = function JsonSchemaViewerComponent(_a) {
  var _a$viewMode = _a.viewMode,
      viewMode = _a$viewMode === void 0 ? 'standalone' : _a$viewMode,
      _a$defaultExpandedDep = _a.defaultExpandedDepth,
      defaultExpandedDepth = _a$defaultExpandedDep === void 0 ? 1 : _a$defaultExpandedDep,
      onGoToRef = _a.onGoToRef,
      renderRowAddon = _a.renderRowAddon,
      hideExamples = _a.hideExamples,
      renderRootTreeLines = _a.renderRootTreeLines,
      disableCrumbs = _a.disableCrumbs,
      rest = __rest(_a, ["viewMode", "defaultExpandedDepth", "onGoToRef", "renderRowAddon", "hideExamples", "renderRootTreeLines", "disableCrumbs"]);

  var options = React.useMemo(function () {
    return {
      defaultExpandedDepth: defaultExpandedDepth,
      viewMode: viewMode,
      onGoToRef: onGoToRef,
      renderRowAddon: renderRowAddon,
      hideExamples: hideExamples,
      renderRootTreeLines: renderRootTreeLines,
      disableCrumbs: disableCrumbs
    };
  }, [defaultExpandedDepth, viewMode, onGoToRef, renderRowAddon, hideExamples, renderRootTreeLines, disableCrumbs]);
  return React.createElement(Provider, null, React.createElement(JSVOptionsContextProvider, {
    value: options
  }, React.createElement(Provider$1, null, React.createElement(JsonSchemaViewerInner, Object.assign({
    viewMode: viewMode
  }, rest)))));
};

var JsonSchemaViewerInner = function JsonSchemaViewerInner(_ref25) {
  var schema = _ref25.schema,
      viewMode = _ref25.viewMode,
      className = _ref25.className,
      resolveRef = _ref25.resolveRef,
      _ref25$emptyText = _ref25.emptyText,
      emptyText = _ref25$emptyText === void 0 ? 'No schema defined' : _ref25$emptyText,
      onTreePopulated = _ref25.onTreePopulated,
      maxHeight = _ref25.maxHeight,
      parentCrumbs = _ref25.parentCrumbs;
  var setHoveredNode = useUpdateAtom(hoveredNodeAtom);
  var onMouseLeave = React.useCallback(function () {
    setHoveredNode(null);
  }, [setHoveredNode]);

  var _React$useMemo = React.useMemo(function () {
    var jsonSchemaTree = new SchemaTree(schema, {
      mergeAllOf: true,
      refResolver: resolveRef
    });
    var nodeCount = 0;

    var shouldNodeBeIncluded = function shouldNodeBeIncluded(node) {
      if (!isRegularNode(node)) return true;
      var validations = node.validations;

      if (!!validations.writeOnly === !!validations.readOnly) {
        return true;
      }

      return !(viewMode === 'read' && !!validations.writeOnly || viewMode === 'write' && !!validations.readOnly);
    };

    jsonSchemaTree.walker.hookInto('filter', function (node) {
      if (shouldNodeBeIncluded(node)) {
        nodeCount++;
        return true;
      }

      return false;
    });
    jsonSchemaTree.populate();
    return {
      jsonSchemaTreeRoot: jsonSchemaTree.root,
      nodeCount: nodeCount
    };
  }, [schema, resolveRef, viewMode]),
      jsonSchemaTreeRoot = _React$useMemo.jsonSchemaTreeRoot,
      nodeCount = _React$useMemo.nodeCount;

  React.useEffect(function () {
    onTreePopulated === null || onTreePopulated === void 0 ? void 0 : onTreePopulated({
      rootNode: jsonSchemaTreeRoot,
      nodeCount: nodeCount
    });
  }, [jsonSchemaTreeRoot, onTreePopulated, nodeCount]);
  var isEmpty = React.useMemo(function () {
    return jsonSchemaTreeRoot.children.every(function (node) {
      return !isRegularNode(node) || node.unknown;
    });
  }, [jsonSchemaTreeRoot]);

  if (isEmpty) {
    return React.createElement(Box, {
      className: cn(className, 'JsonSchemaViewer'),
      fontSize: "sm"
    }, emptyText);
  }

  return React.createElement(Box, {
    className: cn('JsonSchemaViewer', className),
    pos: maxHeight ? 'relative' : undefined,
    overflowY: maxHeight ? 'auto' : undefined,
    onMouseLeave: onMouseLeave,
    style: {
      maxHeight: maxHeight
    }
  }, React.createElement(PathCrumbs, {
    parentCrumbs: parentCrumbs
  }), React.createElement(TopLevelSchemaRow, {
    schemaNode: jsonSchemaTreeRoot.children[0]
  }));
};

var JsonSchemaFallbackComponent = function JsonSchemaFallbackComponent(_ref26) {
  var error = _ref26.error;
  return React.createElement(Box, {
    p: 4
  }, React.createElement(Box, {
    as: "b",
    color: "danger"
  }, "Error"), error !== null ? ": ".concat(error.message) : null);
};

var JsonSchemaViewer = withErrorBoundary(JsonSchemaViewerComponent, {
  FallbackComponent: JsonSchemaFallbackComponent,
  recoverableProps: ['schema']
});
export { JsonSchemaViewer, Validations };